'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n'], ['\n    ', '\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    border-radius: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    border-bottom: none;\n    border: ', '\n    border-radius: ', ';\n    padding: .25rem 1rem;\n    margin-bottom: 2px;\n    overflow: auto;\n'], ['\n    border-bottom: none;\n    border: ', '\n    border-radius: ', ';\n    padding: .25rem 1rem;\n    margin-bottom: 2px;\n    overflow: auto;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _alignments = require('../../../constants/alignments');

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _getTooltip = require('../../../helpers/getTooltip');

var _getTooltip2 = _interopRequireDefault(_getTooltip);

var _getFieldValidationInfo = require('../../../helpers/getFieldValidationInfo');

var _getFieldValidationInfo2 = _interopRequireDefault(_getFieldValidationInfo);

var _separator = require('../../../atoms/separator');

var _separator2 = _interopRequireDefault(_separator);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _input = require('../../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _addressAutocomplete = require('../../../molecules/addressAutocomplete');

var _addressAutocomplete2 = _interopRequireDefault(_addressAutocomplete);

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _error = require('../../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _tooltip = require('../../../molecules/tooltip2');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ValidationBanner = _styledComponents2.default.div(_templateObject, function (_ref) {
    var type = _ref.type;

    switch (type) {
        case 'error':
            return 'background: rgba(255, 0, 78, .15);';
        case 'warning':
            return 'background: rgba(255, 129, 0, .15);';
        default:
            return null;
    }
}, function (_ref2) {
    var index = _ref2.index,
        formattedValue = _ref2.formattedValue;
    return index === 0 && formattedValue ? '0 0 4px 4px' : '4px';
});

var ValueContainer = _styledComponents2.default.div(_templateObject2, function (_ref3) {
    var errors = _ref3.errors,
        warnings = _ref3.warnings,
        formattedValue = _ref3.formattedValue;

    if (formattedValue) {
        switch (true) {
            case errors:
                return '1px solid rgba(255, 0, 78, 1);';
            case warnings:
                return '1px solid rgba(255, 129, 0, 1);';
            default:
                break;
        }
    }
    return 'none';
}, function (_ref4) {
    var errors = _ref4.errors,
        warnings = _ref4.warnings,
        formattedValue = _ref4.formattedValue;
    return errors && formattedValue || warnings && formattedValue ? '4px 4px 0 0' : 'none';
});

var FormInput = function FormInput(_ref5) {
    var label = _ref5.label,
        propValue = _ref5.value,
        _ref5$type = _ref5.type,
        type = _ref5$type === undefined ? 'text' : _ref5$type,
        propPrecision = _ref5.precision,
        _ref5$withCents = _ref5.withCents,
        withCents = _ref5$withCents === undefined ? false : _ref5$withCents,
        minValue = _ref5.minValue,
        maxValue = _ref5.maxValue,
        overrideMaxLength = _ref5.overrideMaxLength,
        overrideMinLength = _ref5.overrideMinLength,
        allowAlphanumericAndSpaceOnly = _ref5.allowAlphanumericAndSpaceOnly,
        propSymbolLabelAlign = _ref5.symbolLabelAlign,
        _changeEvent = _ref5.changeEvent,
        selectEvent = _ref5.selectEvent,
        placeholder = _ref5.placeholder,
        _ref5$noFormMode = _ref5.noFormMode,
        noFormMode = _ref5$noFormMode === undefined ? false : _ref5$noFormMode,
        editing = _ref5.editing,
        allowEdit = _ref5.allowEdit,
        enableAddressSearch = _ref5.enableAddressSearch,
        address = _ref5.address,
        countryCode = _ref5.countryCode,
        reference = _ref5.reference,
        pageCode = _ref5.pageCode,
        sectionCode = _ref5.sectionCode,
        fieldCode = _ref5.fieldCode,
        rowId = _ref5.rowId,
        tooltipInfo = _ref5.tooltipInfo,
        saveTooltipInfo = _ref5.saveTooltipInfo,
        reduceTooltipInfoElement = _ref5.reduceTooltipInfoElement,
        validationInfo = _ref5.validationInfo,
        sectionUIValidation = _ref5.sectionUIValidation,
        position = _ref5.position,
        top = _ref5.top,
        bottom = _ref5.bottom,
        left = _ref5.left,
        right = _ref5.right,
        otherProps = _objectWithoutProperties(_ref5, ['label', 'value', 'type', 'precision', 'withCents', 'minValue', 'maxValue', 'overrideMaxLength', 'overrideMinLength', 'allowAlphanumericAndSpaceOnly', 'symbolLabelAlign', 'changeEvent', 'selectEvent', 'placeholder', 'noFormMode', 'editing', 'allowEdit', 'enableAddressSearch', 'address', 'countryCode', 'reference', 'pageCode', 'sectionCode', 'fieldCode', 'rowId', 'tooltipInfo', 'saveTooltipInfo', 'reduceTooltipInfoElement', 'validationInfo', 'sectionUIValidation', 'position', 'top', 'bottom', 'left', 'right']);

    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var _getFieldValidationIn = (0, _getFieldValidationInfo2.default)(validationInfo, pageCode, sectionCode, fieldCode, rowId),
        errors = _getFieldValidationIn.errors,
        warnings = _getFieldValidationIn.warnings;

    var editMode = editing && allowEdit;

    var precision = void 0;
    var symbolLabel = void 0;
    var symbolLabelAlign = void 0;
    var labelValue = void 0;
    var parts = void 0;

    (0, _react.useEffect)(function () {
        if (propValue !== null && propValue !== undefined && propValue !== unformatValue(value)) {
            if (type.toLowerCase() === 'currency') {
                setValue(formatValue(propValue));
            } else {
                setValue(propValue);
            }
        }
    }, [propValue]);

    var unformatValue = function unformatValue(value) {
        value = value.toString();
        if (value !== '') {
            switch (type.toLowerCase()) {
                case 'currency':
                case 'number':
                case 'percent':
                    return parseFloat(value.replace(/[^0-9.-]/g, ''));

                case 'phone':
                    return value.replace(/[^\d]/g, '');

                case 'text':
                case 'email':
                    return value;

                default:
                    return value;
            }
        }
        return value;
    };

    var handleChange = function handleChange(value) {
        var maxLength = void 0;
        var regex = void 0;
        var newValue = value;

        if (newValue !== '') {
            switch (type.toLowerCase()) {
                case 'text':
                    maxLength = overrideMaxLength || 200;
                    regex = allowAlphanumericAndSpaceOnly ? /^[ A-Za-z0-9]*$/ : /^[ A-Za-z0-9_@./#&+\-`'"’~]*$/;
                    if (!regex.test(newValue)) return;

                    break;
                case 'percent':
                    maxLength = overrideMaxLength ? parseInt(overrideMaxLength, 10) + 1 + parseInt(precision, 10) : 10 + parseInt(precision, 10);

                    // Check if decimal part doesn't exceed precision digits
                    regex = precision > 0 ? new RegExp('^-?\\d*(\\.\\d{0,' + precision + '})?$') : /^-?\\d*$/;
                    if (!regex.test(newValue)) return;

                    // Check if the integer part exceeds maxLength digits
                    parts = newValue.split('.');
                    if (parts[0].length > overrideMaxLength) return;

                    break;
                case 'currency':
                    maxLength = overrideMaxLength || 15;

                    // Remove all characters except digits, '-', and '.'
                    newValue = newValue.replace(/[^0-9.-]/g, '');

                    // Check for multiple dots or dashes
                    var dotMatches = newValue.match(/\./g) || [];
                    var dashMatches = newValue.match(/-/g) || [];

                    if (dotMatches.length > 1 || dashMatches.length > 1) return;

                    // If withCents is false, disallow decimal point
                    if (!withCents && dotMatches.length > 0) return;

                    // Split integer and decimal parts
                    parts = newValue.split('.');
                    var integerPart = parts[0];
                    var decimalPart = parts[1] || '';

                    // Remove leading zeros from integer part
                    integerPart = integerPart.replace(/^0+(?!$)/, '');

                    // Format integer part with commas
                    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                    // Reconstruct newValue
                    newValue = integerPart;

                    if (withCents && parts.length > 1) {
                        // Limit decimal part to 2 digits
                        if (decimalPart.length > 2) {
                            decimalPart = decimalPart.slice(0, 2);
                        }
                        newValue += '.' + decimalPart;
                    }

                    // Adjust maxLength to account for commas
                    var commas = (integerPart.match(/,/g) || []).length;
                    maxLength += commas;

                    // Ensure newValue doesn't exceed maxLength
                    if (newValue.length > maxLength) return;

                    break;
                case 'number':
                    maxLength = overrideMaxLength || 200;
                    newValue = newValue.replace(/[^\d]/g, '');

                    break;
                case 'phone':
                    maxLength = overrideMaxLength || 14;

                    var phoneNumber = newValue.replace(/[^\d]/g, '');
                    var phoneNumberLength = phoneNumber.length;
                    if (phoneNumberLength >= 4 && phoneNumberLength < 7) {
                        newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
                    } else if (phoneNumberLength >= 7) {
                        newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
                    }
                    break;
                case 'email':
                    maxLength = overrideMaxLength || 320;
                    break;
                default:
                    break;
            }

            if (newValue.length > maxLength) return;
        }
        setValue(newValue);
    };

    var handleBlur = function handleBlur() {
        if (type.toLowerCase() === 'currency') {
            var formattedValue = formatValue(value);
            setValue(formattedValue);
        }
        _changeEvent(unformatValue(value));
    };

    var handleClear = function handleClear() {
        setValue('');
        _changeEvent('');
    };

    var formatValue = function formatValue(value) {
        var newValue = value;

        if (newValue) {
            switch (type.toLowerCase()) {
                case 'percent':
                    // Allow for an optional negative sign, any number of digits, optional decimal point,
                    // and up to `precision` number of digits after the decimal point.
                    var regex = precision > 0 ? new RegExp('^-?\\d*(\\.\\d{0,' + precision + '})?$') : /^-?\\d*$/;
                    if (!regex.test(value)) newValue = '';
                    break;
                case 'currency':
                    // Remove commas for processing
                    newValue = newValue.toString().replace(/,/g, '');
                    var numberValue = parseFloat(newValue);

                    if (isNaN(numberValue)) {
                        newValue = '';
                    } else {
                        // Ensure correct number of decimal places
                        if (withCents) {
                            newValue = numberValue.toFixed(2);
                        } else {
                            newValue = numberValue.toFixed(0);
                        }

                        // Format number with commas and decimal places
                        newValue = parseFloat(newValue).toLocaleString('en-US', {
                            minimumFractionDigits: withCents ? 2 : 0,
                            maximumFractionDigits: withCents ? 2 : 0
                        });
                    }
                    break;
                case 'number':
                    newValue = newValue.toString().replace(/[^\d]/g, '');
                    break;
                case 'phone':
                    var phoneNumber = newValue.replace(/[^\d]/g, '');
                    var phoneNumberLength = phoneNumber.length;
                    if (phoneNumberLength === 10) {
                        newValue = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
                    }
                    break;
                default:
                    break;
            }
        }

        return newValue;
    };

    var isValidPhoneNumber = function isValidPhoneNumber() {
        var regEx = /^\(\d{3}\) \d{3}-\d{4}$/;

        if (!value || type.toLowerCase() !== 'phone') return true;

        return regEx.test(value);
    };

    var isValidNumberValue = function isValidNumberValue() {
        var unformattedValue = unformatValue(value);
        if (!unformattedValue || isNaN(maxValue) && isNaN(minValue) || !['percent', 'currency', 'number'].includes(type.toLowerCase())) {
            return true;
        } else if (isNaN(maxValue)) {
            return unformattedValue >= minValue;
        } else if (isNaN(minValue)) {
            return unformattedValue <= maxValue;
        } else {
            return unformattedValue >= minValue && unformattedValue <= maxValue;
        }
    };

    var isValidMinOverriden = function isValidMinOverriden() {
        var isValid = true;
        if (value && ['text', 'number'].includes(type.toLowerCase()) && overrideMinLength !== undefined && overrideMinLength > 0) {
            isValid = value.length >= overrideMinLength;
        }
        return isValid;
    };

    var isValidEmail = function isValidEmail() {
        var regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!value || type.toLowerCase() !== 'email') return true;

        return regEx.test(value);
    };

    switch (type) {
        case 'currency':
            symbolLabel = '$';
            symbolLabelAlign = _alignments.Alignments.left;
            labelValue = '' + symbolLabel + formatValue(value);
            break;
        case 'percent':
            precision = propPrecision || 2;
            symbolLabel = '%';
            symbolLabelAlign = propSymbolLabelAlign || _alignments.Alignments.right;
            labelValue = propSymbolLabelAlign && propSymbolLabelAlign === 'Alignments.left' ? '' + symbolLabel + formatValue(value) : '' + formatValue(value) + symbolLabel;
            break;
        case 'number':
            symbolLabel = null;
            symbolLabelAlign = null;
            labelValue = '' + formatValue(value);
            break;
        case 'text':
        default:
            symbolLabel = null;
            symbolLabelAlign = null;
            labelValue = '' + value;
            break;
    }

    if (noFormMode) {
        return enableAddressSearch ? _react2.default.createElement(_addressAutocomplete2.default, _extends({
            countryCode: countryCode,
            references: reference && reference.references //NOSONAR
            , referencesEvent: reference && reference.doGetReference //NOSONAR
            , placeholder: placeholder || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FormComponents.enterAddress' }),
            address: address,
            changeEvent: function changeEvent(code, value) {
                return _changeEvent(code, value);
            },
            selectEvent: selectEvent,
            top: top,
            bottom: bottom,
            left: left,
            right: right
        }, otherProps)) : _react2.default.createElement(_input2.default, _extends({
            value: value,
            changeEvent: handleChange,
            onBlur: handleBlur,
            onClear: handleClear
            // type={type}
            , error: errors.length > 0 || !isValidPhoneNumber() || !isValidNumberValue() || !isValidEmail() || !isValidMinOverriden(),
            serverErrors: errors,
            serverWarnings: warnings,
            sectionUIValidation: sectionUIValidation,
            position: position,
            symbolLabel: symbolLabel,
            symbolLabelAlign: symbolLabelAlign,
            label: label,
            placeholder: placeholder,
            top: top,
            bottom: bottom,
            left: left,
            right: right
        }, otherProps));
    } else {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_separator2.default, { bottom: _sizes.Sizes.sm,
                orientation: 'horizontal',
                solid: true
            }),
            _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 5,
                            nogutter: true
                        },
                        _react2.default.createElement(
                            _container2.default,
                            { inline: true,
                                verticalAlignment: _alignments.Alignments.center
                            },
                            _react2.default.createElement(_label2.default, { bold: true,
                                textAlign: _alignments.Alignments.left,
                                text: label
                            }),
                            pageCode && sectionCode && fieldCode && _react2.default.createElement(_tooltip2.default, {
                                header: label,
                                text: (0, _getTooltip2.default)(tooltipInfo, pageCode, sectionCode, fieldCode),
                                saveHandler: saveTooltipInfo,
                                reduceHandler: function reduceHandler() {
                                    return function (value) {
                                        reduceTooltipInfoElement({
                                            newTooltip: value,
                                            pageCode: pageCode,
                                            sectionCode: sectionCode,
                                            fieldCode: fieldCode
                                        });
                                    };
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(_column2.default, { xs: 1 }),
                    editMode && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 6,
                                nogutter: true
                            },
                            enableAddressSearch ? _react2.default.createElement(_addressAutocomplete2.default, _extends({
                                countryCode: countryCode,
                                references: reference && reference.references //NOSONAR
                                , referencesEvent: reference && reference.doGetReference //NOSONAR
                                , placeholder: placeholder || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FormComponents.enterAddress' }),
                                address: address,
                                changeEvent: function changeEvent(code, value) {
                                    return _changeEvent(code, value);
                                },
                                selectEvent: selectEvent
                            }, otherProps)) : _react2.default.createElement(_input2.default, {
                                value: value,
                                changeEvent: handleChange,
                                onBlur: handleBlur,
                                onClear: handleClear
                                // type={type}
                                , error: errors.length > 0 || !isValidPhoneNumber() || !isValidNumberValue() || !isValidEmail() || !isValidMinOverriden(),
                                serverErrors: errors,
                                serverWarnings: warnings,
                                sectionUIValidation: sectionUIValidation,
                                position: position,
                                symbolLabel: symbolLabel,
                                symbolLabelAlign: symbolLabelAlign
                            })
                        )
                    ),
                    !editMode && _react2.default.createElement(
                        _column2.default,
                        { xs: 6,
                            nogutter: true
                        },
                        _react2.default.createElement(
                            ValueContainer,
                            { errors: errors.length > 0,
                                warnings: warnings.length > 0,
                                labelValue: value
                            },
                            _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
                                text: labelValue,
                                errors: errors,
                                warnings: warnings
                            })
                        ),
                        errors.length > 0 && errors.map(function (error, index) {
                            return _react2.default.createElement(
                                ValidationBanner,
                                { key: index,
                                    type: 'error',
                                    index: index,
                                    labelValue: value
                                },
                                _react2.default.createElement(_error2.default, { mode: 'error',
                                    size: 24
                                }),
                                _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
                                    text: error.message,
                                    color: _colors.Colors.Error
                                })
                            );
                        }),
                        warnings.length > 0 && warnings.map(function (warning, index) {
                            return _react2.default.createElement(
                                ValidationBanner,
                                { key: index,
                                    type: 'warning',
                                    index: index,
                                    labelValue: value
                                },
                                _react2.default.createElement(_error2.default, { mode: 'warning',
                                    size: 24
                                }),
                                _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left,
                                    text: warning.message,
                                    color: _colors.Colors.Warning
                                })
                            );
                        })
                    )
                )
            )
        );
    }
};

FormInput.propTypes = {
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf(['text', 'currency', 'number', 'percent']).isRequired,
    precision: _propTypes2.default.number,
    withCents: _propTypes2.default.bool,
    minValue: _propTypes2.default.number,
    maxValue: _propTypes2.default.number,
    overrideMaxLength: _propTypes2.default.number,
    overrideMinLength: _propTypes2.default.number,
    allowAlphanumericAndSpaceOnly: _propTypes2.default.bool,
    symbolLabelAlign: _propTypes2.default.string,
    symbolLabel: _propTypes2.default.string,
    changeEvent: _propTypes2.default.func.isRequired,
    selectEvent: _propTypes2.default.func,
    placeholder: _propTypes2.default.string,
    noFormMode: _propTypes2.default.bool,
    editing: _propTypes2.default.bool,
    allowEdit: _propTypes2.default.bool,
    enableAddressSearch: _propTypes2.default.bool,
    address: _propTypes2.default.object,
    countryCode: _propTypes2.default.string,
    reference: _propTypes2.default.object,
    pageCode: _propTypes2.default.string,
    sectionCode: _propTypes2.default.string,
    fieldCode: _propTypes2.default.string,
    rowId: _propTypes2.default.string,
    tooltipInfo: _propTypes2.default.object,
    saveTooltipInfo: _propTypes2.default.func,
    reduceTooltipInfoElement: _propTypes2.default.func,
    validationInfo: _propTypes2.default.object,
    sectionUIValidation: _propTypes2.default.bool,
    position: _propTypes2.default.string,
    top: _propTypes2.default.string,
    bottom: _propTypes2.default.string,
    left: _propTypes2.default.string,
    right: _propTypes2.default.string
};

exports.default = FormInput;